import { MISSION_BY_ID } from '../../data/missions';
import type { HumanRoundRecord } from '../../domain/types';
import { useGameStore } from '../../store/gameStore';
import { MissionCard } from './MissionCard';

interface HumanRoundHistorySectionProps {
  records?: HumanRoundRecord[];
  className?: string;
}

export function HumanRoundHistorySection({
  records: recordsProp,
  className = '',
}: HumanRoundHistorySectionProps) {
  const historyFromStore = useGameStore((s) => s.game.humanRoundHistory);
  const records = recordsProp ?? historyFromStore;

  if (records.length === 0) return null;

  return (
    <section className={className}>
      <h2 className="mb-2 text-xs font-semibold uppercase tracking-wide text-amber-200/80">
        이전 라운드
      </h2>
      <ul className="space-y-3">
        {records.map((record) => {
          const mission = MISSION_BY_ID[record.missionId];
          if (!mission) return null;

          return (
            <li
              key={record.round}
              className="rounded-xl border border-white/10 bg-white/5 p-2"
            >
              <div className="mb-2 flex flex-wrap items-center justify-between gap-2 text-xs">
                <span className="font-semibold text-white/90">라운드 {record.round}</span>
                <span className="text-white/70">베팅 {record.betAmount}점</span>
                <span
                  className={
                    record.success
                      ? 'font-semibold text-emerald-300'
                      : 'font-semibold text-rose-300'
                  }
                >
                  {record.success ? '성공' : '실패'}
                </span>
              </div>
              <div className="flex gap-2 overflow-x-auto pb-1">
                <MissionCard mission={mission} variant="compact" />
              </div>
              {record.missionSwapped && (
                <p className="mt-1 text-[10px] text-white/50">미션 교체 사용</p>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
